import React from 'react';
import styled from 'styled-components';
import { CEB_COLOR_RGBA } from 'app-constants/CEB_COLOR';
import colorForAttitude from 'util/colorForAttitude';

interface PillButtonProps {
  children: React.ReactNode;
  meta?: number | string;
  attitude?: string;
  innerBorderColor?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLButtonElement>) => void;
  'aria-expanded'?: boolean;
  'aria-haspopup'?: string;
  ref?: React.Ref<HTMLButtonElement>;
}

export function PillButton({
  children,
  meta,
  attitude,
  innerBorderColor,
  ...props
}: PillButtonProps) {
  const color = colorForAttitude(attitude);
  return (
    <StyledPillButton
      onClick={props.onClick}
      onBlur={props.onBlur}
      aria-expanded={props['aria-expanded']}
      aria-haspopup={
        props['aria-haspopup'] as
          | 'menu'
          | 'true'
          | 'false'
          | 'listbox'
          | 'tree'
          | 'grid'
          | 'dialog'
          | boolean
      }
      ref={props.ref}
      $color={color}
    >
      {children}
      <span>{meta}</span>
      <i className="fas fa-caret-down" />
    </StyledPillButton>
  );
}

export const StyledPillButton = styled.button<{ $color: string }>`
  background-color: ${({ $color }) => $color};
  border-radius: 1.6em;
  border: 0;
  color: var(--COLOR_WHITE);
  cursor: pointer;
  display: inline-block;
  font-family: var(--FONT_SANS_SERIF);
  font-size: inherit;
  font-weight: bold;
  letter-spacing: 0.02em;
  padding: 0.75em 0.7em 0.55em;
  padding-right: 2.4em;
  position: relative;
  white-space: nowrap;
  &:visited,
  &:active {
    color: var(--COLOR_WHITE);
  }
  &:focus {
    outline: 0;
    box-shadow: 0 0 0 1px
      color-mix(in srgb, var(--COLOR_DANUBE) 60%, transparent);
  }
  > span {
    color: rgba(255, 255, 255, 0.6);
    margin-left: 0.25em;
    display: inline-block;
  }
  > i {
    position: absolute;
    right: 0.75em;
    top: 0;
    height: 1.7em;
    border-left: 1px solid rgba(255, 255, 255, 0.6);
    padding-left: 0.4em;
    padding-top: 0.6em;
  }
`;
